<!--
* 组件名 : 缅甸语字体转换按钮
* 开发者 : JY
*
* 参数: null
*
* 事件:  null
*
-->
<template>
  <div class="font-zawgyi">
    <label class="tgl">
      <input class="fontChange" type="checkbox" ref="fontChange" />
      <span class="cb" data-un="unicode" data-zg="zawgyi"></span>
    </label>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
export default {
  name: "font-zawgyi",
  computed: {
    ...mapState("global", ["fontStatus"]),
  },

  created() {},
  mounted() {
    setTimeout(() => {
      $("body.zawgyi").length && window.unicodeToZawgyi();
    }, 120);
    this.update_current_fonts();
    this.$P.$on("page-change-ended", () => {
      $("body.zawgyi").length && window.unicodeToZawgyi();
    });
  },
  methods: {
    ...mapMutations("global", ["updateFontStatus"]),
    /**
     * 更新当前字体按钮状态
     */
    update_current_fonts() {
      let btn_status = () => {
        $("body.zawgyi").length
          ? this.updateFontStatus(true)
          : this.updateFontStatus(false);
      };
      btn_status();

      $(this.$refs.fontChange).change(() => {
        setTimeout(() => btn_status(), 100);
      });

      setTimeout(() => {
        $(this.$refs.fontChange).prop({ checked: this.fontStatus });
      }, 120);
    },
  },
};
</script>

<style lang="scss">
.tgl {
  outline: 0;
  cursor: pointer;
  width: 86px;
  height: 28px;
  margin: 0 10px;
  input[type="checkbox"] {
    display: none !important;
  }

  span {
    position: relative;
    display: block;
    width: 100%;
    height: 100%;
    overflow: hidden;
    text-align: center;
    line-height: 26px !important;
    border-radius: 2em;
    transition: padding 0.3s ease;
    border: 1px solid #3a3a3a;

    &::before {
      content: "";
      display: block;
      height: 100%;
      color: #3a3a3a;
      font-size: 14px;
    }

    &::after {
      position: absolute;
      display: block;
      content: "";
      border-radius: 2em;
      width: 18px;
      height: 18px;
      left: 4px;
      top: 4px;
      background: #3a3a3a;
      transition: left 0.3s cubic-bezier(0.175, 0.885, 0.32, 0.97);
    }
  }

  input[type="checkbox"]:checked {
    & + span {
      padding-right: 18px;
      padding-left: 0;
      line-height: 24px !important;

      &::after {
        left: calc(100% - 20px - 4px);
      }
    }

    & + span {
      &::before {
        content: attr(data-zg);
      }
    }
  }

  input[type="checkbox"] {
    & + span {
      padding-left: 22px;
      &::before {
        content: attr(data-un);
      }
    }
  }
}
.font-zawgyi {
  @include flex(center);
  label {
    display: inline-block;
  }
}
</style>
